import { render, staticRenderFns } from "./RejectedJobs.vue?vue&type=template&id=7a879c2c"
import script from "./RejectedJobs.vue?vue&type=script&lang=js"
export * from "./RejectedJobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports